import styled from '@mui/system/styled';
import { Grid } from '@mui/material';
import Paper from '@mui/material/Paper';

export const DashboardTemplateItemCnt = styled(Grid)({});
export const StyledItem = styled('div')({
  border: '1px solid #E0E0E0',
  boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.06)',
  borderRadius: 14,
  overflow: 'hidden',
  '&:hover': {
    border: '1px solid #6868FE',
    cursor: 'pointer',
  },
  '.contentCnt': {
    padding: '12px 16px 22px 16px',
    '.heading': {
      color: '#212121',
      fontSize: 15,
      fontWeight: 700,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '98%',
    },
    '.subTitle': {
      color: '#616161',
      fontSize: 13,
      fontWeight: 400,
      minHeight: 120,
    },
  },
  '.imageCnt': {
    width: '100%',
  },
});
export const TemplateImage = styled('img')({
  width: '100%',
});
